export { getSelectionDetail } from './getSelectionDetail';
export { getNodePathFromNodeOffset } from './getNodePathFromNodeOffset';
export { extendToTextNode } from './extendToTextNode';
export { extendToDocumentContent } from './extendToDocumentContent';
export { removeHighlightElements } from './removeHighlightElements';
export { applyHighlightSpan } from './applyHighlightSpan';
export { resolvePathWithOffset } from './resolvePathWithOffset';
export { clipSelectionRange } from './clipSelectionRange';
export { RangeInternal } from './RangeInternal';
export { getTextLengthByPath } from './getTextLengthByPath';



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/index.tsx